import { useFormik } from 'formik'
import * as api from '../../services/api'
import { useAuth } from "../../hooks/useAuth"
import { waitForExtratoPdfReady } from "../../services/extratoPdf"
import { useCore } from "../../hooks/useCore"
import { useItemsStore } from '../../contexts/zustand/onboarding';
import { useNavigate } from "react-router-dom"
import { LooseObject } from "../../types/core"
import CheckIcon from '@mui/icons-material/Check'
import ImageIcon from '@mui/icons-material/Image'
import { BalanceProps } from "../../types/balance"
import { LightMode } from "../../styles/lightMode"
import { systemMessages } from "../../utils/messages"
import useWindowSize from "../../hooks/useWindowSize"
import { formatMoney } from "../../utils/format-money"
import { toast, ToastContainer } from "react-toastify"
import { handleFileRead } from "../../utils/get-base64"
import BusinessIcon from '@mui/icons-material/Business'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import FactCheckIcon from '@mui/icons-material/FactCheck'
import { LoadingPage } from "../../components/LoadingPage"
import UploadFileIcon from '@mui/icons-material/UploadFile'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf'
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar'
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd'
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn'
import { FaCarSide, FaHelicopter, FaMotorcycle, FaTractor, FaTrailer } from 'react-icons/fa'
import { GiBus, GiTruck } from 'react-icons/gi'
import { RiTruckFill } from 'react-icons/ri'
import { ListParameter, ParameterProps } from "../../types/parameter"
import { ListAllProductProps, ProductProps } from "../../types/product"
import { useCallback, useEffect, useLayoutEffect, useReducer, useState } from "react"
import { inputValueType, notTextOrNumber } from "../Api/CreateOrUpdateApi/value_type"
import { Alert, Button, Card, CardContent, Checkbox, Chip, Divider, FormControlLabel, FormGroup, Grid, Stack, TextField, Tooltip, Typography } from "@mui/material"
import ValueTypeSelect from './ValueTypeSelect';
import ListApiSelect from './ListApiSelect';

const colheitadeira = require('../../images/colheitadeiraCinza.png')
const colheitadeiraBranca = require('../../images/colheitadeiraBranca.png')

type initialStateProps = {
  originalParameters: ParameterProps[]
  parameters: ParameterProps[]
  parametersRequired: ParameterProps[]
  initialValues: LooseObject
}

const initialState: initialStateProps = {
  originalParameters: [],
  parameters: [],
  parametersRequired: [],
  initialValues: {
    rescue: false
  }
}

function reducer(state: any, action: any) {
  switch (action.type) {
    case 'SET_ORIGINAL_PARAMETERS':
      return { ...state, originalParameters: action.payload };
    case 'SET_PARAMETERS':
      return { ...state, parameters: action.payload };
    case 'SET_INITIAL_VALUES':
      return { ...state, initialValues: action.payload };
    case 'SET_PARAMETERS_REQUIRED':
      return { ...state, parametersRequired: action.payload };
    default:
      throw new Error('Invalid action type');
  }
}

export default function Dashboard(): JSX.Element {
  const { user } = useAuth()
  const navigate = useNavigate()
  const { width } = useWindowSize()
  const { setTitleBar, setPathTitleBar } = useCore()

  const { setCheckPermissionOnboarding } = useItemsStore()

  const [rescueVisibility, setRescueVisibility] = useState<boolean>(true)
  const [loading, setLoading] = useState<boolean>(true)
  const [balance, setBalance] = useState<BalanceProps>()
  const [awaiting, setAwaiting] = useState<boolean>(false)
  const [state, dispatch] = useReducer(reducer, initialState)
  const [chipsProduct, setChipsProduct] = useState<ProductProps[]>([])
  const [vehicleConsultation, setVehicleConsultation] = useState<ProductProps[]>([])
  const [vehicleConsultationExtrato, setVehicleConsultationExtrato] = useState<ProductProps[]>([])
  const [validationConsultation, setValidationConsultation] = useState<ProductProps[]>([])
  const [cadastralConsultationPf, setCadastralConsultationPf] = useState<ProductProps[]>([])
  const [cadastralConsultationPj, setCadastralConsultationPj] = useState<ProductProps[]>([])
  const [priceConsultation, setPriceConsultation] = useState<ProductProps[]>([])

  const [tokenOnboarding, setTokenOnboarding] = useState<string>("")

  const { handleChange, handleSubmit, values, setFieldValue, errors, touched } = useFormik({
    initialValues: state.initialValues,
    enableReinitialize: true,
    validate: (values) => {
      const errors: LooseObject = {}
      state.parameters.forEach((param: ParameterProps) => {
        if (state.parametersRequired.indexOf(param.description) > -1) {
          const key = `${param.name}|${param.api_id}`
          const value = values[key]
          if (value === undefined || value === null || String(value).trim() === '') {
            errors[key] = 'Campo obrigatório'
          }
        }
      })
      return errors
    },
    onSubmit: createCall
  })

  async function createCall() {
    setAwaiting(true)

    const isExtrato = chipsProduct.some((chip) => chip.extrato_enabled)
    toast.loading(
      isExtrato ? "Aguarde, estamos gerando a sua consulta" : "Aguarde...",
      { position: toast.POSITION.TOP_RIGHT }
    )

    const data = {
      "products": chipsProduct.map((chip) => {
        return chip.id
      }),
      "rescue": values.rescue ?? false,
      "data": {}
    }

    let _parameters: LooseObject = {}

    state.originalParameters.forEach((originalItem: ParameterProps) => {
      state.parameters.forEach((item: ParameterProps) => {
        if (item.description === originalItem.description) {
          const rawValue = !values[`${item.name}|${item.api_id}`] && item.value_type === "3"
            ? item.boolean_default
            : values[`${item.name}|${item.api_id}`] ?? ''

          const finalValue =
            originalItem.local === "3" && originalItem.value_type !== "4" && originalItem.value_type !== "5" && originalItem.value_type !== "6" && rawValue !== null && rawValue !== undefined
              ? String(rawValue)
              : rawValue

          _parameters[`${originalItem.name}|${originalItem.api_id}`] = {
            'value': finalValue,
          }
        }
      })
    })

    data.data = _parameters

    const response = await api.post('call/create/', data) as { [key: string]: any }

    if (response.status === 201) {
      const callId = response.data.content.id
      const extratoProduct = (response.data.content.extrato_products ?? []).find(
        (product: { id: string; extrato_enabled: boolean }) => product.extrato_enabled
      )

      if (extratoProduct) {
        try {
          await waitForExtratoPdfReady(callId, extratoProduct.id)
        } catch (error) {
          // não trava a navegação — a tela de detalhe tenta buscar de novo
          // sozinha e cai no fallback dela caso continue falhando
          console.error(error)
        }
      }

      setAwaiting(false)
      toast.dismiss()
      toast.success("Sucesso 😃! Aguarde mais um pouco, estamos redirecionando para você...", {
        position: toast.POSITION.TOP_RIGHT
      })
      await getOverBalance().catch(console.error)
      setTimeout(() => {
        return navigate(`/query/${callId}`)
      }, 3000)
    } else if (response.status === 200) {
      setAwaiting(false)
      toast.dismiss()
      toast.success("Sua consulta será processada, verifique no Histórico de Consultas", {
        position: toast.POSITION.TOP_RIGHT
      })
      await getOverBalance().catch(console.error)
      setTimeout(() => {
        return navigate('/queries')
      }, 3000)
      handleChangeStep(false)
    } else {
      setAwaiting(false)
      toast.dismiss()
      toast.error(systemMessages.error, {
        position: toast.POSITION.TOP_RIGHT
      })
    }
  }

  const getProducts = async () => {
    const response = await api.get('product/list/all/') as ListAllProductProps

    let vehicle_consultation = []
    let vehicle_consultation_extrato = []
    let cadastral_consultation_pf = []
    let validation_consultation = []
    let cadastral_consultation_pj = []
    let price_consultation = []

    if (response.content.length > 0) {
      for (let i = 0; i < response.content.length; i++) {
        if (response.content[i].category === "1") {
          if (response.content[i].extrato_enabled) {
            vehicle_consultation_extrato.push(response.content[i])
          } else {
            vehicle_consultation.push(response.content[i])
          }
        } else if (response.content[i].category === "2") {
          cadastral_consultation_pf.push(response.content[i])
        } else if (response.content[i].category === "3") {
          validation_consultation.push(response.content[i])
        } else if (response.content[i].category === "4") {
          cadastral_consultation_pj.push(response.content[i])
        } else if (response.content[i].category === "5") {
          price_consultation.push(response.content[i])
        }
      }

      setVehicleConsultation(vehicle_consultation)
      setVehicleConsultationExtrato(vehicle_consultation_extrato)
      setCadastralConsultationPf(cadastral_consultation_pf)
      setCadastralConsultationPj(cadastral_consultation_pj)
      setValidationConsultation(validation_consultation)
      setPriceConsultation(price_consultation)
    }
    setLoading(false)
  }

  const getParameters = async (data: object) => {
    setLoading(true)
    let parametersDescription: string[] = []
    let parametersDescriptionRequired: string[] = []

    const response = await api.patch('product/list/parameters/', data) as { [key: string]: any }
    const parametersResponse = response.data as ListParameter
    dispatch({ type: 'SET_ORIGINAL_PARAMETERS', payload: parametersResponse.content })

    let _initialValues: LooseObject = {
      "rescue": false
    }

    let _parameters: ParameterProps[] = []

    setRescueVisibility(true)

    // eslint-disable-next-line array-callback-return
    parametersResponse.content.map((item: ParameterProps) => {
      if (["4", "5", "6"].indexOf(item.value_type) > -1) setRescueVisibility(false)
      _initialValues[`${item.name}|${item.api_id}`] = ''
      if (parametersDescription.indexOf(item.description) === -1) {
        parametersDescription.push(item.description)
        _parameters.push(item)
      }
      if (parametersDescriptionRequired.indexOf(item.description) === -1) {
        if (item.required) parametersDescriptionRequired.push(item.description)
      }
    })

    dispatch({ type: 'SET_PARAMETERS', payload: _parameters })
    dispatch({ type: 'SET_INITIAL_VALUES', payload: _initialValues })
    dispatch({ type: 'SET_PARAMETERS_REQUIRED', payload: parametersDescriptionRequired })
    setLoading(false)
  }

  const getOverBalance = useCallback(async () => {
    if (user?.corporate_id) {
      await api.get(`company/info_balance/${user?.corporate_id}`).then((response: any) => {
        setBalance(response.content)
      })
    }
  }, [user?.corporate_id])

  const [step, setStep] = useState<boolean>(false)

  const handleChangeStep = async (value: boolean) => {
    setStep(value)

    if (value) {
      let productsId = chipsProduct.map((chip) => chip.id)
      await getParameters({ "products_id": productsId })
    } else {
      dispatch({ type: 'SET_INITIAL_VALUES', payload: {} })
      dispatch({ type: 'SET_PARAMETERS', payload: [] })
      for (const property in values) {
        delete values[property]
      }
    }
  }

  const getIconBySubcategory = (subcategory: string, isSelected?: boolean) => {
    const color = 'default'
    switch (subcategory) {
      case "1": return <FaTractor size={20} color={color} />
      case "2": return <FaHelicopter size={20} color={color} />
      case "3": return <FaTrailer size={20} color={color} />
      case "4": return <RiTruckFill size={20} color={color} />
      case "5": return (
        <div style={{ display: 'flex', flexDirection: "column", lineHeight: 0 }}>
          <GiTruck size={14} color={color} style={{ marginBottom: -2 }} />
          <GiBus size={14} color={color} style={{ marginTop: -2 }} />
        </div>
      )
      case "6": return (
        <img
          src={isSelected ? colheitadeiraBranca : colheitadeira}
          alt="colheitadeira"
          style={{ width: 20, height: 20 }}
        />
      )
      case "7": return (
        <div style={{ display: 'flex', flexDirection: "column", lineHeight: 0 }}>
          <FaMotorcycle size={14} color={color} style={{ marginBottom: -2 }} />
          <FaCarSide size={14} color={color} style={{ marginTop: -2 }} />
        </div>
      )
      default: return <MonetizationOnIcon />
    }
  }

  const handleAddOrDeleteChip = (chip: ProductProps) => () => {
    if (balance && parseFloat(balance.current_balance) <= 0) {
      return toast.error("Você já atingiu o seu limite monetário esse mês!", {
        position: toast.POSITION.TOP_RIGHT
      })
    }

    if (chipsProduct.filter((item) => item.id === chip.id).length > 0) {
      setChipsProduct((chips) => chips.filter((item) => item.id !== chip.id))
    } else {
      if (chipsProduct.some((item) => item.extrato_enabled)) {
        return toast.error("Este produto é um pacote de informações e não pode ser realizado com outras consultas", {
          position: toast.POSITION.TOP_RIGHT
        })
      }

      if (chip.extrato_enabled && chipsProduct.length > 0) {
        return toast.error("Este produto é uma consulta avulsa e não pode ser realizado com um pacote de informações", {
          position: toast.POSITION.TOP_RIGHT
        })
      }

      if (chip.category === "5" && chipsProduct.some((item) => item.category === "5" && item.id !== chip.id)) {
        return toast.error("Você só pode selecionar um produto de Consulta de Preço por vez.", {
          position: toast.POSITION.TOP_RIGHT
        })
      }
      setChipsProduct([...chipsProduct, chip])
    }
  }

  const chipHoverSx = {
    '&:hover': {
      filter: 'brightness(0.92)'
    }
  }

  const normalizeParamName = (name: string) => name.replace(/^{|}$/g, "")

  const getFormikFieldKey = (p: ParameterProps) => `${p.name}|${p.api_id}`

  const findParamByNormalizedName = (apiId: string, normalizedName: string) => {
    return state.parameters.find((p: ParameterProps) => {
      return p.api_id === apiId && normalizeParamName(p.name) === normalizedName
    })
  }

  const getValueByNormalizedName = (apiId: string, normalizedName: string) => {
    const p = findParamByNormalizedName(apiId, normalizedName)
    if (!p) return ""
    return values[getFormikFieldKey(p)]
  }

  const areDependsOnReady = (p: ParameterProps) => {
    const deps = p.ui?.depends_on ?? []
    return deps.every((dep: string) => {
      const v = getValueByNormalizedName(p.api_id, dep)
      return v !== undefined && v !== null && String(v).length > 0
    })
  }

  // Se for group select, renderiza apenas 1x (no primeiro field do group_fields)
  const shouldRenderGroupLeader = (p: ParameterProps) => {
    const groupFields = p.ui?.group_fields
    if (!groupFields || groupFields.length === 0) return true

    const normalized = normalizeParamName(p.name)
    return normalized === groupFields[0]
  }

  const orderedParameters = (() => {
    const hasListSelect = state.parameters.some((p: ParameterProps) => {
      return p.ui?.component === "select" && !!p.list_api_id
    })

    if (!hasListSelect) return state.parameters

    return state.parameters
      .map((p: ParameterProps, idx: number) => {
        const isListSelect = p.ui?.component === "select" && !!p.list_api_id
        const order = isListSelect ? 2 : p.ui ? 1 : 0
        return { p, idx, order }
      })
      .sort((a: { p: ParameterProps; idx: number; order: number }, b: { p: ParameterProps; idx: number; order: number }) => {
        if (a.order !== b.order) return a.order - b.order
        return a.idx - b.idx
      })
      .map((item: { p: ParameterProps }) => item.p)
  })()

  useEffect(() => {
    const fetchData = async () => {
      if (user?.corporate_id) {

        const [getToken, getPermissionOnboarding] = await Promise.all([
          api.get(`company/retrieve/${user?.corporate_id}/`),
          api.get(`user/list_permissions/?user_id=${user.id}&permission_name=onboarding`)
        ]);

        const tokenOnboardingApi = (getToken as any).content.token_onboarding

        setTokenOnboarding(tokenOnboardingApi)

        setCheckPermissionOnboarding({
          'token': tokenOnboardingApi,
          'using_onboarding': (getToken as any).content.using_onboarding,
          'permission_onboarding': (getPermissionOnboarding as any).content === "1"
        })
      }
    };

    fetchData()

    getProducts().catch(console.error)
  }, [user?.corporate_id, user?.id, setCheckPermissionOnboarding])

  useLayoutEffect(() => {
    setTitleBar("Dashboard")
    setPathTitleBar(undefined)
    getOverBalance().catch(console.error)
  }, [setPathTitleBar, setTitleBar, getOverBalance])

  const hasBothVehicleGroups = vehicleConsultation.length > 0 && vehicleConsultationExtrato.length > 0

  return (
    <>
      <ToastContainer />
      {
        !loading
          ? vehicleConsultation.length === 0 && vehicleConsultationExtrato.length === 0 && cadastralConsultationPf.length === 0 && validationConsultation.length === 0 && cadastralConsultationPj.length === 0 && priceConsultation.length === 0
            ? <Alert color="error" severity="warning">
              <strong>
                Ainda não existem produtos cadastrados na plataforma!
              </strong>
            </Alert>
            : <form
              onSubmit={handleSubmit}
            >
              {
                // @ts-ignore
                balance && ["2", "3"].indexOf(user?.profile) > -1
                  ? <>
                    <Alert color="info" variant="outlined" icon={
                      width >= 600
                        ? <Tooltip
                          title={`Os valores informados abaixo estão relacionado a empresa ${user?.corporate_name} ao qual você faz parte e NÃO individual por usuário.`}
                        >
                          <MonetizationOnIcon />
                        </Tooltip>
                        : <></>
                    }>
                      <Typography variant="subtitle1" align={width >= 1146 ? 'left' : 'center'}>
                        <strong>INFORMAÇÕES MONETÁRIA DESTE MÊS</strong>
                      </Typography>
                      <Stack
                        direction={width < 600 ? 'column' : 'row'}
                        spacing={1}
                        sx={{
                          textAlign: "center",
                          display: width >= 1500 ? 'flex' : 'grid',
                          gap: 1,
                          gridTemplateColumns:
                            width < 600 ? '1fr' :
                              width <= 1200 ? '1fr' : 'repeat(3, 1fr)',
                          '& .MuiChip-root': {
                            marginLeft: width >= 600 ? '0 !important' : undefined,
                          }
                        }}>
                        <Chip
                          label={
                            <>
                              <strong>Limite mensal:</strong> <span style={{ fontSize: "1rem" }}>R$ {formatMoney(balance.balance)}</span>
                            </>
                          }
                          color="secondary"
                          size="small"
                        />
                        <Chip
                          label={
                            <>
                              <strong>Consumido em consultas:</strong> <span style={{ fontSize: "1rem" }}>R$ {formatMoney(balance.current_balance_query)}</span>
                            </>
                          }
                          color="secondary"
                          size="small"
                        />
                        <Chip
                          label={
                            <>
                              <strong>Consumido em processamentos:</strong> <span style={{ fontSize: "1rem" }}>R$ {formatMoney(balance.current_balance_processing)}</span>
                            </>
                          }
                          color="secondary"
                          size="small"
                        />
                        {/* <Chip 
                              label={
                                <>
                                  <strong>Consumido em checkmatch:</strong> <span style={{ fontSize: "1rem" }}>R$ {formatMoney(balance.current_balance_checkmatch)}</span>
                                </>
                              }
                              color="secondary"
                              size="small"
                            /> */}

                        {tokenOnboarding && (
                          <Chip
                            label={
                              <>
                                <strong>Consumido em onboardings:</strong> <span style={{ fontSize: "1rem" }}>R$ {formatMoney(balance.current_balance_onboarding)}</span>
                              </>
                            }
                            color="secondary"
                            size="small"
                          />
                        )}
                      </Stack>
                    </Alert>
                    <br />
                  </>
                  : <></>
              }
              <Grid
                container
                spacing={2}
                alignItems="center"
                justifyContent="center"
                display={
                  !step
                    ? 'flex'
                    : 'none'
                }
              >
                <Grid item md={12} xs={12}>
                  <Alert severity="info">
                    <strong>
                      Abaixo pequisas disponíveis para consultas. Selecione todas que quiser e clique em avançar.
                    </strong>
                  </Alert>
                </Grid>
                {
                  (vehicleConsultation.length > 0 || vehicleConsultationExtrato.length > 0)
                    ? <Grid item md={12} xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid #65B32C' }}>
                        <CardContent>
                          <Typography variant="h5" component="div">
                            Consultas veiculares
                          </Typography>
                          <Typography variant="body2" sx={{ mb: 1.5 }} color="text.secondary">
                            Faça pesquisas veiculares informando placa, chassi ou ambos de acordo com o produto escolhido
                          </Typography>
                          {
                            vehicleConsultation.length > 0 && (
                              <>
                                {hasBothVehicleGroups && (
                                  <Typography variant="subtitle2" sx={{ mt: 2, color: '#424242', fontWeight: '600' }}>
                                    Consulta por informação
                                  </Typography>
                                )}
                                {
                                  vehicleConsultation.map((product) => {
                                    const isSelected = chipsProduct.some((chip) => chip.id === product.id)
                                    return (
                                      <Tooltip
                                        key={`vehicle-consultation-${product.id}`}
                                        title={product.description}
                                        arrow
                                        placement="right"
                                        sx={{ margin: 1 }}
                                      >
                                        <Chip
                                          icon={<DirectionsCarIcon />}
                                          label={product.name}
                                          onClick={handleAddOrDeleteChip(product)}
                                          color={isSelected ? "success" : "default"}
                                          sx={{ m: 1, ...chipHoverSx }}
                                        />
                                      </Tooltip>
                                    )
                                  })
                                }
                              </>
                            )
                          }
                          {
                            vehicleConsultationExtrato.length > 0 && (
                              <>
                                {hasBothVehicleGroups && (
                                  <>
                                    <Divider sx={{ my: 2 }} />
                                    <Typography variant="subtitle2" sx={{ color: '#424242', fontWeight: '600' }}>
                                      Consulta por pacote de informação
                                    </Typography>
                                  </>
                                )}
                                {
                                  vehicleConsultationExtrato.map((product) => {
                                    const isSelected = chipsProduct.some((chip) => chip.id === product.id)
                                    return (
                                      <Tooltip
                                        key={`vehicle-consultation-extrato-${product.id}`}
                                        title={product.description}
                                        arrow
                                        placement="right"
                                        sx={{ margin: 1 }}
                                      >
                                        <Chip
                                          icon={<DirectionsCarIcon />}
                                          label={product.name}
                                          onClick={handleAddOrDeleteChip(product)}
                                          color={isSelected ? "success" : "default"}
                                          sx={{ m: 1, ...chipHoverSx }}
                                        />
                                      </Tooltip>
                                    )
                                  })
                                }
                              </>
                            )
                          }
                        </CardContent>
                      </Card>
                    </Grid>
                    : <></>
                }
                {
                  cadastralConsultationPf.length > 0
                    ? <Grid item md={12} xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid #65B32C' }}>
                        <CardContent>
                          <Typography variant="h5" component="div">
                            Consultas cadastrais PF
                          </Typography>
                          <Typography variant="body2" sx={{ mb: 1.5 }} color="text.secondary">
                            Faça pesquisas cadastrais de pessoas físicas informando CPF ou diversos outros dados de acordo com o produto escolhido
                          </Typography>
                          {
                            cadastralConsultationPf.map((product) => {
                              const isSelected = chipsProduct.some((chip) => chip.id === product.id)
                              return (
                                <Tooltip
                                  key={`cadastral-consultation-pf-${product.id}`}
                                  title={product.description}
                                  arrow
                                  placement="right"
                                  sx={{ margin: 1 }}
                                >
                                  <Chip
                                    icon={<AssignmentIndIcon />}
                                    label={product.name}
                                    onClick={handleAddOrDeleteChip(product)}
                                    color={isSelected ? "success" : "default"}
                                    sx={{ m: 1, ...chipHoverSx }}
                                  />
                                </Tooltip>
                              )
                            })
                          }
                        </CardContent>
                      </Card>
                    </Grid>
                    : <></>
                }
                {
                  cadastralConsultationPj.length > 0
                    ? <Grid item md={12} xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid #65B32C' }}>
                        <CardContent>
                          <Typography variant="h5" component="div">
                            Consultas cadastrais PJ
                          </Typography>
                          <Typography variant="body2" sx={{ mb: 1.5 }} color="text.secondary">
                            Faça pesquisas cadastrais de pessoa jurídica informando CNPJ ou diversos outros dados de acordo com o produto escolhido
                          </Typography>
                          {
                            cadastralConsultationPj.map((product) => {
                              const isSelected = chipsProduct.some((chip) => chip.id === product.id)
                              return (
                                <Tooltip
                                  key={`cadastral-consultation-pj-${product.id}`}
                                  title={product.description}
                                  arrow
                                  placement="right"
                                  sx={{ margin: 1 }}
                                >
                                  <Chip
                                    icon={<BusinessIcon />}
                                    label={product.name}
                                    onClick={handleAddOrDeleteChip(product)}
                                    color={isSelected ? "success" : "default"}
                                    sx={{ m: 1, ...chipHoverSx }}
                                  />
                                </Tooltip>
                              )
                            })
                          }
                        </CardContent>
                      </Card>
                    </Grid>
                    : <></>
                }
                {
                  validationConsultation.length > 0
                    ? <Grid item md={12} xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid #65B32C' }}>
                        <CardContent>
                          <Typography variant="h5" component="div">
                            Validações
                          </Typography>
                          <Typography variant="body2" sx={{ mb: 1.5 }} color="text.secondary">
                            Faça validações documentais ou diversos outros de acordo com o produto escolhido
                          </Typography>
                          {
                            validationConsultation.map((product) => {
                              const isSelected = chipsProduct.some((chip) => chip.id === product.id)
                              return (
                                <Tooltip
                                  key={`validation-consultation-${product.id}`}
                                  title={product.description}
                                  arrow
                                  placement="right"
                                  sx={{ margin: 1 }}
                                >
                                  <Chip
                                    icon={<FactCheckIcon />}
                                    label={product.name}
                                    onClick={handleAddOrDeleteChip(product)}
                                    color={isSelected ? "success" : "default"}
                                    sx={{ m: 1, ...chipHoverSx }}
                                  />
                                </Tooltip>
                              )
                            })
                          }
                        </CardContent>
                      </Card>
                    </Grid>
                  : <></>
                }
                {
                  priceConsultation.length > 0
                    ? <Grid item md={12} xs={12}>
                      <Card elevation={0} sx={{ border: '1px solid #65B32C' }}>
                        <CardContent>
                          <Typography variant="h5" component="div">
                            Consulta de Preços
                          </Typography>
                          <Typography variant="body2" sx={{ mb: 1.5 }} color="text.secondary">
                            Pesquise e valide valores de mercado de forma rápida e segura
                          </Typography>
                          {
                            priceConsultation.map((product) => {
                              const isSelected = chipsProduct.some((chip) => chip.id === product.id)
                              return (
                                <Tooltip
                                  key={`price-consultation-${product.id}`}
                                  title={product.description}
                                  arrow
                                  placement="right"
                                  sx={{ margin: 1 }}
                                >
                                  <Chip
                                    icon={getIconBySubcategory(product.subcategory, isSelected)}
                                    label={product.name}
                                    onClick={handleAddOrDeleteChip(product)}
                                    color={isSelected ? "success" : "default"}
                                    sx={{ m: 1, ...chipHoverSx }}
                                  />
                                </Tooltip>
                              )
                            })
                          }
                        </CardContent>
                      </Card>
                    </Grid>
                  : <></>
                }
              </Grid>
              <Grid
                container
                spacing={2}
                alignItems="center"
                justifyContent="center"
                display={step ? 'flex' : 'none'}
              >
                <Grid item md={12} xs={12}>
                  <Alert severity="info">
                    <strong>Você está fazendo as seguintes consultas:</strong>
                    <Grid
                      container
                      spacing={1}
                      alignItems="center"
                      justifyContent="flex-start"
                      marginTop={1}
                    >
                      {
                        chipsProduct.map((chip) => {
                          const isPrice = chip.category === "5"
                          const icon = isPrice
                            ? getIconBySubcategory(chip.subcategory, true)
                            : chip.category === "1"
                              ? <DirectionsCarIcon />
                              : chip.category === "2"
                                ? <AssignmentIndIcon />
                                : chip.category === "3"
                                  ? <FactCheckIcon />
                                  : <BusinessIcon />

                          const color = "success"
                          // const color = isPrice
                          //   ? "success"
                          //   : chip.category === "1"
                          //     ? "success"
                          //     : chip.category === "2"
                          //       ? "success"
                          //       : chip.category === "3"
                          //         ? "success"
                          //         : "success"

                          return (
                            <Grid item md="auto" xs="auto" key={`chip-${chip.id}`}>
                              <Tooltip
                                title={chip.description && chip.description.length > 0 ? chip.description : chip.name}
                                sx={{ margin: 1 }}
                              >
                                <Chip
                                  icon={icon}
                                  label={chip.name}
                                  color={color}
                                  sx={{ m: 1, ...chipHoverSx }}
                                />
                              </Tooltip>
                            </Grid>
                          )
                        })
                      }
                    </Grid>
                  </Alert>
                </Grid>
                <Grid
                  item
                  md={12} xs={12}
                >
                  <p style={{ color: LightMode.error.main }}>
                    <strong>
                      Por favor, preencha os campos solicitados (campos marcados com * são obrigatórios)
                    </strong>
                  </p>
                </Grid>
                {
                  orderedParameters.map((parameter: ParameterProps) => {
                    // 1) Se for select vindo de LIST API, respeita depends_on e group leader
                    const isListSelect = parameter.ui?.component === "select" && !!parameter.list_api_id

                    if (isListSelect) {
                      // Verifica se dependências estão prontas para habilitar/desabilitar
                      const isReady = areDependsOnReady(parameter)

                      // se for group select, renderiza apenas uma vez (leader)
                      if (!shouldRenderGroupLeader(parameter)) return null

                      return (
                        <Grid
                          key={`parameter-${parameter.name}-${parameter.api_id}`}
                          item
                          md={12}
                          xs={12}
                        >
                          <ListApiSelect
                            parameter={parameter}
                            allParameters={state.parameters}
                            values={values}
                            setFieldValue={setFieldValue}
                            disabled={!isReady}
                            required={state.parametersRequired.indexOf(parameter.description) > -1}
                            error={Boolean(errors[`${parameter.name}|${parameter.api_id}`])}
                            touched={Boolean(touched[`${parameter.name}|${parameter.api_id}`])}
                          />
                        </Grid>
                      )
                    }

                    return (
                      <Grid
                        key={`parameter-${parameter.name}-${parameter.api_id}`}
                        item
                        md={12} xs={12}
                      >
                        {
                          notTextOrNumber.indexOf(parameter.value_type) === -1
                            ? <TextField
                              fullWidth
                              label={parameter.description}
                              type={inputValueType[parameter.value_type]}
                              required={state.parametersRequired.indexOf(parameter.description) > -1}
                              name={`${parameter.name}|${parameter.api_id}`}
                              onChange={handleChange}
                            />
                            : parameter.value_type === '3'
                              ? <FormGroup>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      name={`${parameter.name}|${parameter.api_id}`}
                                      onChange={(e) => {
                                        if (e.target.checked) {
                                          setFieldValue(`${parameter.name}|${parameter.api_id}`, parameter.boolean_value)
                                        } else {
                                          setFieldValue(`${parameter.name}|${parameter.api_id}`, parameter.boolean_default)
                                        }
                                      }}
                                    />
                                  }
                                  label={parameter.description}
                                />
                              </FormGroup>
                              : <FormGroup>
                                {
                                  parameter.value_type === '4'
                                    ? <label
                                      className={
                                        `label-input-file ${values[`${parameter.name}|${parameter.api_id}`] ? "label-input-file-success" : "label-input-file-default"}`
                                      }
                                      htmlFor={`${parameter.name}|${parameter.api_id}`}
                                    >
                                      <ImageIcon /> {
                                        values[`${parameter.name}|${parameter.api_id}`]
                                          ? values[`${parameter.name}|${parameter.api_id}`]['filename']
                                          : `Clique aqui e ${parameter.description} ${state.parametersRequired.indexOf(parameter.description) > -1 ? "*" : ""}`
                                      }
                                      <input
                                        style={{ display: "none" }}
                                        id={`${parameter.name}|${parameter.api_id}`}
                                        type="file"
                                        name={parameter.name}
                                        onChange={async (e) => {
                                          if (e.target.files) {
                                            let base64 = await handleFileRead(e)
                                            setFieldValue(`${parameter.name}|${parameter.api_id}`, base64)
                                          } else {
                                            setFieldValue(`${parameter.name}|${parameter.api_id}`, '')
                                          }
                                        }}
                                        accept='image/*'
                                      />
                                    </label>
                                    : parameter.value_type === '5'
                                      ? <label
                                        className={
                                          `label-input-file ${values[`${parameter.name}|${parameter.api_id}`] ? "label-input-file-success" : "label-input-file-default"}`
                                        }
                                        htmlFor={`${parameter.name}|${parameter.api_id}`}
                                      >
                                        <PictureAsPdfIcon /> {
                                          values[`${parameter.name}|${parameter.api_id}`]
                                            ? values[`${parameter.name}|${parameter.api_id}`]['filename']
                                            : `Clique aqui e ${parameter.description} ${state.parametersRequired.indexOf(parameter.description) > -1 ? "*" : ""}`
                                        }
                                        <input
                                          style={{ display: "none" }}
                                          id={`${parameter.name}|${parameter.api_id}`}
                                          type="file"
                                          name={parameter.name}
                                          onChange={async (e) => {
                                            if (e.target.files) {
                                              let base64 = await handleFileRead(e)
                                              setFieldValue(`${parameter.name}|${parameter.api_id}`, base64)
                                            } else {
                                              setFieldValue(`${parameter.name}|${parameter.api_id}`, '')
                                            }
                                          }}
                                          accept='application/pdf'
                                        />
                                      </label>
                                      : parameter.value_type === '6' ? <label
                                        className={
                                          `label-input-file ${values[`${parameter.name}|${parameter.api_id}`] ? "label-input-file-success" : "label-input-file-default"}`
                                        }
                                        htmlFor={`${parameter.name}|${parameter.api_id}`}
                                      >
                                        <UploadFileIcon /> {
                                          values[`${parameter.name}|${parameter.api_id}`]
                                            ? values[`${parameter.name}|${parameter.api_id}`]['filename']
                                            : `Clique aqui e ${parameter.description} ${state.parametersRequired.indexOf(parameter.description) > -1 ? "*" : ""}`
                                        }
                                        <input
                                          style={{ display: "none" }}
                                          id={`${parameter.name}|${parameter.api_id}`}
                                          type="file"
                                          name={parameter.name}
                                          onChange={async (e) => {
                                            if (e.target.files) {
                                              let base64 = await handleFileRead(e)
                                              setFieldValue(`${parameter.name}|${parameter.api_id}`, base64)
                                            } else {
                                              setFieldValue(`${parameter.name}|${parameter.api_id}`, '')
                                            }
                                          }}
                                        />
                                      </label> : <ValueTypeSelect
                                        parameter={parameter}
                                        value={values[`${parameter.name}|${parameter.api_id}`]}
                                        setFieldValue={setFieldValue}
                                      />
                                }
                              </FormGroup>
                        }
                      </Grid>
                    )
                  })
                }
                {
                  rescueVisibility
                    ? <Grid
                      item
                      md={12} xs={12}
                    >
                      <FormGroup>
                        <FormControlLabel
                          control={
                            <Checkbox
                              name="rescue"
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setFieldValue("rescue", true)
                                } else {
                                  setFieldValue("rescue", false)
                                }
                              }}
                              checked={values.rescue}
                              value={values.rescue}
                            />
                          }
                          label="Caso houver realizado essa consulta nos últimos 30 dias e deseja resgatá-la, marque essa opção"
                        />
                      </FormGroup>
                    </Grid>
                    : <></>
                }
              </Grid>
              <Grid
                container
                alignItems="center"
                justifyContent="center"
                textAlign="center"
              >
                <Grid
                  item
                  md={12} xs={12}
                  marginTop={3}
                >
                  <Button
                    variant="contained"
                    onClick={() => { handleChangeStep(!step) }}
                    disabled={chipsProduct.length === 0}
                    color={step ? "secondary" : "success"}
                    disableElevation
                    sx={{ marginRight: 2 }}
                  >
                    {
                      step
                        ? <ArrowBackIcon />
                        : chipsProduct.length === 0
                          ? 'Selecione um produto primeiro'
                          : 'Avançar'
                    }
                    {
                      step
                        ? 'Voltar'
                        : <ArrowForwardIcon />
                    }
                  </Button>
                  {
                    step
                      ? <Button
                        variant="contained"
                        disabled={chipsProduct.length === 0 || awaiting}
                        type="submit"
                        color="success"
                        disableElevation
                      >
                        Consultar <CheckIcon />
                      </Button>
                      : <></>
                  }
                </Grid>
              </Grid>
            </form>
          : <LoadingPage />
      }
    </>
  )
}
